import DicStatus from './dicStatus'
export default DicStatus